import { render, staticRenderFns } from "./DistributionRebate.vue?vue&type=template&id=953e6962&scoped=true"
import script from "./DistributionRebate.vue?vue&type=script&lang=js"
export * from "./DistributionRebate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "953e6962",
  null
  
)

export default component.exports